import { render } from "./functional_information_profitAndLossStructures.vue?vue&type=template&id=36a871f6"
import script from "./functional_information_profitAndLossStructures.vue?vue&type=script&lang=js"
export * from "./functional_information_profitAndLossStructures.vue?vue&type=script&lang=js"

import "./functional_information_profitAndLossStructures.vue?vue&type=style&index=0&id=36a871f6&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__